import {
  Model,
  ResponseFill,
  HttpIgnore, ValidationRequired, IResource, ValidationCNPJ,
} from 'simpli-web-sdk'
import moment from 'moment'
import * as Helper from '@/helpers'
import {Region} from '@/enums/Region'
import {DeliverySlaStatus} from '@/enums/DeliverySlaStatus'
import {ItrackCollection} from '@/helpers'
import {TipoSistema} from '@/enums/TipoSistema'
import {UF} from '@/enums/UF'
import {DeliveryAuditGeo} from '@/enums/DeliveryAuditGeo'

@HttpIgnore()
export default class DeliverySlaRequest extends Model {
  readonly $name: string = 'DeliverySlaRequest'

  idFilial = Helper.getIdFilial()

  allSistema = ItrackCollection.allSistema
  allRegion = ItrackCollection.allRegion.prependNull('app.all')
  allSlaStatus = ItrackCollection.allSlaStatus.prependNull('app.all')
  allCentroDeCusto = ItrackCollection.allCentroDeCusto.prependNull('app.all')
  allTipoInsumo = ItrackCollection.allTipoInsumo.prependNull('app.all')
  allAuditGeo = ItrackCollection.allAuditGeo.prependNull('app.all')

  @ResponseFill('from')
  fromDate: string | null = null

  toDate: string | null = null

  @ResponseFill('sigla')
  sigla: string | null = null

  @ResponseFill('documentoResponsavel')
  documentResponsavel: string | null = null

  @ResponseFill('uf')
  uf: UF | null = null

  @ResponseFill('city')
  city: string | null = null

  @ResponseFill('idTipoCriacao')
  @ValidationRequired()
  idTipoCriacao: number | null = null

  @ResponseFill('idTipoFinalizacao')
  @ValidationRequired()
  idTipoFinalizacao: number | null = null

  @ResponseFill('region')
  @ValidationRequired()
  region: Region | null = null

  @ResponseFill('slaPendente')
  slaStatus: DeliverySlaStatus | null = null

  @ResponseFill('idInsumo')
  @ValidationRequired()
  idInsumo: number | null = null

  @ResponseFill('auditoriaGeo')
  auditGeo: DeliveryAuditGeo | null = null

  @ResponseFill('documentoDestinatario')
  @ValidationCNPJ()
  documentoDestinatario: string | null = null

  @ResponseFill()
  get to() {
    // we should send the next day to the server, the prop endDate is used only to control what the user input
    return !this.toDate ? this.toDate : moment(this.toDate).add(1, 'day').format()
  }

  set to(val) {
    if (val) {
      // in the way back we need to subtract, so the params in the route dont mess up
      this.toDate = moment(val).subtract(1, 'day').format()
    }
  }

  get ufCollection() {
    return ItrackCollection.getUfCollection(this.region).prependNull('app.all')
  }

  get regionResource() {
    return this.allRegion.get(this.region)
  }
  set regionResource(val: IResource | null) {
    this.region = val && val.$id as Region || null
  }

  get tipoFinalizacaoResource() {
    return this.allSistema.get(this.idTipoFinalizacao)
  }
  set tipoFinalizacaoResource(val: IResource | null) {
    this.idTipoFinalizacao = val && val.$id as TipoSistema || null
  }

  get tipoCriacaoResource() {
    return this.allSistema.get(this.idTipoCriacao)
  }
  set tipoCriacaoResource(val: IResource | null) {
    this.idTipoCriacao = val && val.$id as TipoSistema || null
  }

  get slaStatusResource() {
    return this.allSlaStatus.get(this.slaStatus)
  }
  set slaStatusResource(val: IResource | null) {
    this.slaStatus = val && val.$id as DeliverySlaStatus || null
  }

  get insumoResource() {
    return this.allCentroDeCusto.get(this.idInsumo)
  }
  set insumoCustoResource(val: IResource | null) {
    this.idInsumo = val && val.$id as number || null
  }

  get ufResource() {
    return this.ufCollection.get(this.uf)
  }
  set ufResource(val: IResource | null) {
    this.uf = val && val.$id as UF || null
  }

  get auditGeoResource() {
    return this.allAuditGeo.get(this.auditGeo)
  }
  set auditGeoResource(val: IResource | null) {
    this.auditGeo = val && val.$id as DeliveryAuditGeo || null
  }

}
